import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import '../css/consulting2020.css';

class EventConsulting2020 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      scrollTop: 0,
      page: "left"
    };
  }

  componentDidMount() {
    window.pageVisit("consulting", "2012");
    window.addEventListener("scroll", this.onScroll);
  }

  onScroll = (e) => {
    const scrollTop = ("scroll", e.srcElement.scrollingElement.scrollTop);
    this.setState({scrollTop: scrollTop});
  }
  
  render() {
    return (
      <Fragment>
        <div id="skipNavi">
          <h1 className="blind">TOZ StudyCenter 스킵네비게이션</h1>
          <ul>
            <li><a href="#contents" className="skipLink">본문바로가기</a></li>
            <li><a href="#topmenu" className="skipLink">주메뉴바로가기</a></li>
          </ul>
        </div>
        <div id="doc" className="isPage">	
          <div id="pg-code" className="doc-pg">
            <div id="container-wrap"  className="div-cont consulting2020" style={{background: '#fff'}}>
              <div id="contents" style={{background: '#fff'}}>
                <div className="BgTop"></div>
                <div className="TabWrap">
                  <button className={"BtnLeft" + (this.state.page === "left" ? " on" : "")} onClick={() => this.setState({ page: "left" })}></button>
                  <button className={"BtnRight" + (this.state.page === "right" ? " on" : "")} onClick={() => this.setState({ page: "right" })}></button>
                </div>
                <div className="BgWrap" style={{ height: this.state.page === "left" ? "680vw" : "800vw" }}>
                  <div className={"BgLeft" + (this.state.page === "left" ? " on" : "")}>
                    <a href="https://bit.ly/2SNLux2" target="_blank" className="BtnTozpds"></a>
                  </div>
                  <div className={"BgRight" + (this.state.page === "right" ? " on" : "")}>
                    <a href="https://bit.ly/2SNLux2" target="_blank" className="BtnTozpds"></a>
                  </div>
                </div>
              </div>
              <Link to="/" className={`banner ${this.state.scrollTop > 500 ? "show" : ""}`} onClick={() => window.pageComplete("consulting", "2012")}></Link>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

export default EventConsulting2020;
